import React, { useContext } from "react";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { checkForHttpErrors } from "../upload/DocumentUploadButton";
import UploadIcon from "../../../../../common/upload/UploadIcon";
import { MessageContext } from "../../../../../common/message";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../../../../../common/authorization/AuthorizeService";
import Tooltip from "../../../../../common/tooltip/Tooltip";

function DecisionUploadButton({
  requests,
  uploadUrl = `${process.env.REACT_APP_GATEWAY_URL}/upload`,
  acceptDocumentTypes = "",
  formDataAsJson,
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const upload = async (e, id, uid) => {
    const file = e.currentTarget.files[0];

    const formData = new FormData();
    formData.append("file", file);
    Object.keys(formDataAsJson).forEach((key) => formData.append(key, formDataAsJson[key]));

    const request = new XMLHttpRequest();

    request.onload = checkForHttpErrors(request);

    request.open("POST", uploadUrl);
    /*identity */

    let token = await getAccessToken();

    request.setRequestHeader("Request-Origin", "pisarnica");
    request.setRequestHeader("Authorization", `Bearer ${token}`);

    request.send(formData);

    request.onreadystatechange = function () {
      if (this.readyState === 4) {
        message.toggle({
          title: t("modalMessage.titleInfo"),
          content: t("requests.decisionAcceptance.action.upload"),
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
            history.push(`/requirementsInResolving/upload/${id}/previewDecision/${uid}`, [
              request.responseText,
              file.name,
              requests.title,
              requests.submissionDate,
              requests.subject,
              requests.id,
              requests.uid,
              file,
            ]);
          },
        });
        return request.responseText;
      }
    };
  };

  const handleUpload = (e) => {
    upload(e, requests.id, requests.uid);
  };

  function returnUploadIcon() {
    return (
      <Tooltip content={"Pridruži dokument"}>
        <UploadIcon
          acceptDocumentTypes={acceptDocumentTypes}
          requests={requests}
          onChange={(e) => handleUpload(e)}
          label={<FontAwesomeIcon className="is-clickable" icon={faFileUpload} size="2x" />}
        />
      </Tooltip>
    );
  }

  return <>{returnUploadIcon()}</>;
}

export default DecisionUploadButton;
